export const SKELETON_FILTERS = Array.from({ length: 5 }, (_, index) => index);
